import React, {Component} from 'react';
import moment from 'moment';
import FamilyMembers from './FamilyMembers';
import FamilyTableView from './FamilyTableView';
import XrayViewer from "../XrayViewer";
import Medical from "./Medical"
import {Button} from "semantic-ui-react";
import {connect} from "react-redux";
import {getMedical} from "../../redux/modules/billing";
class FamilyView extends Component {

    state = {activeKey: this.props.selectedPT_Num,
            showMedicalPopup:false}
    componentDidMount = () => {
        const {dispatch, selectedPT_Num,selectedPracticeName} = this.props;
        if(selectedPT_Num&&selectedPracticeName) {
            dispatch(getMedical(selectedPT_Num,selectedPracticeName));
        }

    }
    getPractice = (location) => {
        let practice = location;
        if (practice === 'sanantonio')
            practice = 'San Antonio';
        else if (practice === 'mineralwells')
            practice = 'Mineral Wells';
        else if (practice === 'epmontana')
            practice = 'EP Montana';
        else if (practice === 'epzaragosa' || practice === 'epzaragoza')
            practice = 'EP Zaragoza';
        else if (practice === 'mcallen')
            practice = 'McAllen';
        else if (practice === 'grandprairie')
            practice = 'Grand Prairie';

        return practice;
    }

    treatmentPlanCalculation = (treatmentPlan, selectedPatient) => {
        let txPlanTotal = 0;
        let txPlanIgnoreTotal = 0;
        if (treatmentPlan[selectedPatient.PT_Num] && treatmentPlan[selectedPatient.PT_Num].length) {
            const txPlanIgnore = selectedPatient.txPlanIgnore ? JSON.parse(selectedPatient.txPlanIgnore) : {};
            treatmentPlan[selectedPatient.PT_Num].forEach(item => {
                if (item.ProcFee && txPlanIgnore[item.ProcNum] !== "true") {
                    txPlanTotal += item.ProcFee;
                }
                if (txPlanIgnore[item.ProcNum] === "true")
                    txPlanIgnoreTotal++;
            })
            return ({
                txPlanTotal: txPlanTotal.toFixed(2),
                txPlanIgnoreTotal,
                notSelectedTotal: treatmentPlan[selectedPatient.PT_Num].length - txPlanIgnoreTotal
            });
        } else {
            return null;
        }
    }

    matchTxTotal = (treatmentPlan, txPlanIgnore) => {
        let txPlanIgnoreObj = txPlanIgnore ? JSON.parse(txPlanIgnore) : {};
        let txPlanTotal = 0;

        treatmentPlan.forEach(item => {
            if (item.ProcFee && txPlanIgnoreObj[item.ProcNum] !== 'true') {
                txPlanTotal += item.ProcFee;
            }
        });
        return txPlanTotal;
    };

    getStatusTextClass = (BrokenChild) => {
        const {BrokenChildTable} = this.props;
        let response = {}
        BrokenChild.forEach(item => {

            let text = null
            let cls = '';
            const NextAptDays = item.Next_Apt ? moment(item.Next_Apt).diff(moment(), 'days') : item.Next_Apt;

            const matchTxTotal = (BrokenChildTable.treatmentPlan && Object.keys(BrokenChildTable.treatmentPlan).length && BrokenChildTable.treatmentPlan[item.PT_Num]) ?
                this.matchTxTotal(BrokenChildTable.treatmentPlan[item.PT_Num], item.txPlanIgnore) : 0;

            const lastExamDate = (BrokenChildTable.lastExamResult && Object.keys(BrokenChildTable.lastExamResult).length && BrokenChildTable.lastExamResult[item.PT_Num]) ?
                BrokenChildTable.lastExamResult[item.PT_Num] : 0;

            if (item.Next_Apt && NextAptDays <= 14 && NextAptDays >= 0 && matchTxTotal) {
                text = `TX - ${matchTxTotal.toFixed(2)}`;
                cls = 'text-green';
            } else if ((!item.Next_Apt || item.Next_Apt < 0 || NextAptDays > 14) && matchTxTotal) {
                text = `TX - ${matchTxTotal.toFixed(2)}`;
                cls = 'text-red';
            } else if (!item.Days_Since_Last_Visit && item.Next_Apt) {
                text = 'NP';
                cls = 'text-green';
            } else if (!item.Days_Since_Last_Visit && !item.Next_Apt) {
                text = 'NP';
                cls = 'text-red';
            } else if (item.age < 3 && item.Next_Apt) {
                text = 'FDH';
                cls = 'text-green';
            } else if (item.age < 3 && !item.Next_Apt) {
                text = 'FDH';
                cls = 'text-red';
            } else if (lastExamDate > 180 && item.Next_Apt) {
                text = 'RC';
                cls = 'text-green';
            } else if (lastExamDate > 180 && !item.Next_Apt) {
                text = 'RC';
                cls = 'text-red';
            } else if (lastExamDate && lastExamDate <= 180 && item.Next_Apt) {
                text = 'ND';
                cls = 'text-green';
            } else if (lastExamDate && lastExamDate <= 180 && !item.Next_Apt) {
                text = 'ND';
                cls = 'text-red';
            } else if (!lastExamDate && item.LastVisit) {
                text = 'RC';
                cls = 'text-red';
            }

            response[item.PT_Num] = {class: cls, text: text ? ' - ' + text : ''}
        });
        return response;
    };

    onChange = (activeKey) => {
        this.setState({activeKey});
    };

    PhoneNumbersString = (PatNum, Guarantor, lastPhoneStatusParam, phoneArray) => {

        const savePhoneArray = [];
        const newArray = phoneArray.filter((item) => {
            if (item && item !== '' && savePhoneArray.includes(item.trim()) === false) {
                savePhoneArray.push(item.trim());
                return true;
            } else {
                return false;
            }
        });

        let response = [];
        if (newArray.length) {
            newArray.forEach((phoneNumber, key) => {
                if (phoneNumber) {
                    phoneNumber = phoneNumber.trim();
                    const lastPhoneStatus = (lastPhoneStatusParam && Object.keys(lastPhoneStatusParam).length) ? JSON.parse(lastPhoneStatusParam) : {};
                    let phoneStatusState = this.state[`phoneStatus-${PatNum}`] || lastPhoneStatus;
                    const bellStatus = (phoneStatusState[phoneNumber] && phoneStatusState[phoneNumber][1]) ? false : true;
                    const messageStatus = (phoneStatusState[phoneNumber] && phoneStatusState[phoneNumber][2]) ? false : true;
                    const phoneStatus = (phoneStatusState[phoneNumber] && phoneStatusState[phoneNumber][3]) ? false : true;
                    const headStatus = (phoneStatusState[phoneNumber] && phoneStatusState[phoneNumber][4]) ? false : true;

                    response.push(<div className="phoneTolTipImg" key={key}>
                        <img alt="icon-bell" src={`/images/icon-bell${((!bellStatus) ? '-active' : '')}.png`}/>
                        <img alt="icon-message" src={`/images/icon-message${((!messageStatus) ? '-active' : '')}.png`}/>
                        <img alt="icon-phone" src={`/images/icon-phone${((!phoneStatus) ? '-active' : '')}.png`}/>
                        <img alt="icon-head" src={`/images/icon-head${((!headStatus) ? '-active' : '')}.png`}/>
                        <p className="phoneTolTipP">{phoneNumber}</p>
                    </div>);
                }
            });
        }
        return response;
    }
    hideMedical=()=>{
        this.setState({showMedicalPopup:false})
    }
    phoneTolTip = (PatNum) => {
        let flag = 'true';
        if (this.state.phoneTolTip && this.state.phoneTolTip[PatNum] === 'true')
            flag = 'false'

        this.setState({phoneTolTip: {[PatNum]: flag}});
    }

    render() {

        const {BrokenChildTable, selectedPT_Num, selectedPractice, selectedPracticeName, changeTab, BrokenChild,medical} = this.props;
        let selectedPatient = BrokenChild ? BrokenChild.filter((item) => item.PT_Num === selectedPT_Num) : null;
        const {showMedicalPopup}=this.state;
        // Assign first Dependent, If selected petient does not find in BrokenChild array
        if (BrokenChild && !selectedPatient[0]) {
            selectedPatient[0] = BrokenChild[0];
        }
        let vitals=""
        if(medical&&medical.vitals&&medical.vitals.length>0){
            vitals=medical.vitals[0].vitals
        }
        let location2 = this.getPractice(selectedPractice);
        let treatmentPlanCalculation = (BrokenChildTable.treatmentPlan && Object.keys(BrokenChildTable.treatmentPlan).length && selectedPatient[0]) ? this.treatmentPlanCalculation(BrokenChildTable.treatmentPlan, selectedPatient[0]) : {};
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="leftSection">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card pd0">
                                        <div className="card-header bg-color-primary">
                                            <h3 className="headingSub color-white">Patient Information</h3>
                                            <Button primary className="notes" onClick={()=>{this.setState({showMedicalPopup: true})}}>Medical</Button>
                                        </div>
                                        <div className="card-content patientInfo">
                                            <div className="row">
                                                <div className="col-12">
                                                    {selectedPatient.length && selectedPatient.map(item =>
                                                        <table key={item.PT_Num} className="table mb-0 wd100">
                                                            <tbody>
                                                            <tr>
                                                                <td>
                                                                    <label> Patient Name</label>
                                                                    <p className="color-secondary">{item.PT_Name}</p>
                                                                </td>
                                                                <td><label>Patient ID</label> <p
                                                                    className="color-secondary">{item.PT_Num}</p></td>
                                                            </tr>
                                                            <tr>
                                                                <td><label>Age</label>  <p
                                                                    className="color-secondary">{item.age}</p></td>
                                                                <td><label>Birth Date</label>  <p
                                                                    className="color-secondary">{item.BirthDate}</p>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td><label>Practice</label>  <p
                                                                    className="color-secondary">{selectedPracticeName || selectedPractice}</p></td>
                                                                <td><label>Visit Count</label>  <p
                                                                    className="color-secondary">{item.Insurance && item.Insurance.Visit_Count ? item.Insurance.Visit_Count : ''}</p>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td><label>Last Visit</label>  <p
                                                                    className="color-secondary">{item.LastVisit ? item.LastVisit : ''}</p>
                                                                </td>
                                                                <td><label>Next Apt</label>  <p
                                                                    className="color-secondary">{(item.Next_Apt) ? item.Next_Apt : ''}</p>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td><label>Show Rate (%)</label>  <p
                                                                    className="color-secondary">{item.Insurance && item.Insurance.show_rate ? item.Insurance.show_rate : ''}</p>
                                                                </td>
                                                                <td><label>Insurance</label> <p
                                                                    className="color-secondary">{item.Insurance && item.Insurance.Insurance ? item.Insurance.Insurance : ''}</p>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td><label>Best Contact Time</label> <p
                                                                    className="color-secondary">{item.bestContactTime}</p>
                                                                </td>
                                                                <td><label>Ins Verified</label> <p
                                                                    className="color-secondary">{item.DateLastVerified ? item.DateLastVerified : item.Insurance && item.Insurance.DateLastVerified ? moment(item.Insurance.DateLastVerified).format("MM/DD/YYYY") : ''}</p>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td><label>Phone Number</label>
                                                                    <div>
                                                                        {(item.HmPhone || item.WkPhone || item.WirelessPhone || item.phone) ?
                                                                            <div className="phoneTolTipOuter">
                                                                                <a onClick={() => this.phoneTolTip(item.PT_Num)}>
                                                                                    {item.HmPhone || item.WkPhone || item.WirelessPhone || item.phone}
                                                                                </a>
                                                                                {this.state.phoneTolTip && this.state.phoneTolTip[item.PT_Num] === 'true' &&
                                                                                <div
                                                                                    className="phoneTolTip childPage-phoneTolTip">
                                                                                    {this.PhoneNumbersString(item.PT_Num, item.Guarantor, item.phoneStatus, [item.HmPhone, item.WkPhone, item.WirelessPhone, item.phone])}
                                                                                </div>
                                                                                }
                                                                            </div> : ''
                                                                        }
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <XrayViewer
                                                                        {...this.props}
                                                                        practice={selectedPracticeName || selectedPractice}
                                                                        patientNumber={item.PT_Num}/>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td><label>Vitals</label> <p
                                                                    className="color-secondary">{vitals}</p>
                                                                </td>
                                                                <td><label>Ins Verified</label> <p
                                                                    className="color-secondary">{item.DateLastVerified ? item.DateLastVerified : item.Insurance && item.Insurance.DateLastVerified ? moment(item.Insurance.DateLastVerified).format("MM/DD/YYYY") : ''}</p>
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card pd0 mt20 patientInfo">
                                        <div className="card-header">
                                            <h3 className="headingSub color-primary">Family View</h3>
                                        </div>
                                        <div className="card-content">
                                            <div className="row">
                                                <FamilyMembers location={location2} BrokenChild={BrokenChild}
                                                               selectedPT_Num={selectedPT_Num} changeTab={changeTab}
                                                               treatmentPlanCalculation={treatmentPlanCalculation}
                                                               BrokenChildTable={BrokenChildTable}
                                                               getStatusTextClass={this.getStatusTextClass}
                                                               onChange={this.onChange} activeKey={this.state.activeKey}
                                                               PhoneNumbersString={this.PhoneNumbersString}
                                                               phoneTolTip={this.phoneTolTip}
                                                               phoneTolTipState={(this.state.phoneTolTip) ? this.state.phoneTolTip : null}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="rightSection">
                            <FamilyTableView BrokenChildTable={BrokenChildTable} selectedPatient={selectedPatient[0]}
                                             treatmentPlanCalculation={treatmentPlanCalculation} selectedPracticeName={selectedPracticeName}
                                             dispatch={this.props.dispatch}
                            />
                        </div>
                    </div>
                </div>
                {showMedicalPopup && <Medical hideMedical={this.hideMedical}
                                              dispatch={this.props.dispatch}
                                              selectedPT_Num={this.props.selectedPT_Num}
                                              selectedPractice={selectedPractice}
                                              selectedPracticeName={selectedPracticeName}
                />
                   }
            </div>

        );
    }
}
export default connect(
    state => ({
        user: state.get('auth').get('user'),
        medical: state.get('billing').get('medical'),
    }))(FamilyView);